import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import PageContainer from '@/components/PageContainer';
import PageHeader from '@/components/PageHeader';
import { ASSETS, FIRM_INFO } from '@/lib/assets';
import { Mail } from 'lucide-react';

function TeamCard({ name, role, bio, image, email, reverse = false }) {
  return (
    <article className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center py-12 border-t border-[var(--color-taupe)]/25 first:border-t-0 first:pt-0" data-testid={`member-${email.split('@')[0]}`}>
      <div className={`md:col-span-4 ${reverse ? 'md:order-2' : ''}`}>
        <div className="relative aspect-[3/4] max-w-[320px] mx-auto md:mx-0 overflow-hidden bg-[var(--color-taupe)]/10">
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
            loading="lazy"
          />
          <div className="absolute -bottom-1 -right-1 w-16 h-16 border-r-2 border-b-2 border-[var(--color-gold)]" />
        </div>
      </div>
      <div className={`md:col-span-8 ${reverse ? 'md:order-1' : ''}`}>
        <p className="text-[11px] tracking-[0.35em] uppercase text-[var(--color-gold)] font-semibold mb-2">
          {role}
        </p>
        <h3 className="font-display text-3xl md:text-4xl text-navy mb-4">{name}</h3>
        <div className="h-px w-12 bg-[var(--color-gold)] mb-5" />
        <div className="space-y-3 text-[15.5px] leading-[1.85] text-navy/80 text-justify">
          {bio.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        <a
          href={`mailto:${email}`}
          className="inline-flex items-center gap-2 mt-6 text-[12px] tracking-[0.25em] uppercase text-navy hover:text-[var(--color-gold)] border-b border-[var(--color-gold)] pb-1 transition-colors"
          data-testid={`email-${email.split('@')[0]}`}
        >
          <Mail size={14} />
          {email}
        </a>
      </div>
    </article>
  );
}

export default function Equipe() {
  const { t } = useLang();
  const e = t.equipe;

  return (
    <PageContainer>
      <PageHeader kicker={e.kicker} title={e.title} />

      <div className="mt-12">
        <TeamCard
          name={e.members.laurence.name}
          role={e.members.laurence.role}
          bio={e.members.laurence.bio}
          image={ASSETS.team.laurence}
          email={FIRM_INFO.emails.laurence}
        />
        <TeamCard
          name={e.members.ageron.name}
          role={e.members.ageron.role}
          bio={e.members.ageron.bio}
          image={ASSETS.team.ageron}
          email={FIRM_INFO.emails.ageron}
          reverse
        />
        <TeamCard
          name={e.members.caroline.name}
          role={e.members.caroline.role}
          bio={e.members.caroline.bio}
          image={ASSETS.team.caroline}
          email={FIRM_INFO.emails.caroline}
        />
      </div>
    </PageContainer>
  );
}
